import { useEffect, useRef, useState } from "react";

import { Session } from "../types/working-model";

export enum ETimestampStatus {
	preLive = 'pre-live',
	live = 'live',
	ended = 'ended'
}

const useTimestampStatus = (session: Session | null, interval = 5000): ETimestampStatus => {
	const [timestampStatus, setTimestampStatus] = useState<ETimestampStatus>(ETimestampStatus.preLive);

	const timeout = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		const check = () => {
			if (!session) return;
			if (timeout.current) {
				clearTimeout(timeout.current);
			}
			if (session?.timestamp && session?.end_timestamp) {
				const date = Date.now();
				const timestamp = new Date(session.timestamp);
				const end_timestamp = new Date(session.end_timestamp);
				if (timestamp.getTime() < date && end_timestamp.getTime() > date) {
					setTimestampStatus(ETimestampStatus.live);
				} else if (date > end_timestamp.getTime()) {
					setTimestampStatus(ETimestampStatus.ended);
				} else {
					setTimestampStatus(ETimestampStatus.preLive);
				}
			}
			timeout.current = setTimeout(() => {
				check();
			}, interval);
		};

		check();

		return () => {
			if (timeout.current) {
				clearTimeout(timeout.current);
			}
		};
	}, [
		session,
		interval,
	]);

	return timestampStatus;
};

export default useTimestampStatus;
